import React, { useState } from "react";
import { limitText } from "../../Utility/Utility";
import { Img } from "../../Components/UI/UI";
import TagManager from 'react-gtm-module';

export const AccomodationsItem = (props) => {
  const desc = props.desc != undefined ? props.desc : "";
  const imgVideo = props.imgVideo != undefined ? props.imgVideo : "";
  const id = props.id != undefined ? props.id : "";
  const href = props.href != undefined ? props.href : "";
  const [isHover, setIsHover] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  let cancelCoverCss;

  if (isClicked) {
    cancelCoverCss = " ac-cover-hide";
  } else {
    cancelCoverCss = " ";
  }

  return (
    <div
      className={
        "ac-wrapper-accomodationsItem ac-wrapper-accomodationsItem-" + id
      }
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="ac-accomodations-content">
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={"ac-accomodations-link" + cancelCoverCss}
          onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'Accomodations', 'click_cta':desc,}})}

        >
          <Img desktopImg={imgVideo} imgCss={"ac-cover-img"} />
          <div className="ac-title">
            <h3>{limitText(desc, 100)}</h3>
          </div>
        </a>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Components/Accomodations/AccomodationsItem.js